import { ContextMenuHost } from '../components/ContextMenu.tsx';
import { useUi } from '../state/ui-store.ts';
import { CommandPalette, ShortcutsDialog } from './dialogs/CommandDialogs.tsx';
import { DuplicateDialog } from './dialogs/DuplicateDialog.tsx';
import { ProjectSettingsDialog } from './dialogs/ProjectSettingsDialog.tsx';
import { ExportDialog } from './export/ExportDialog.tsx';

export function Dialogs() {
  const dialog = useUi((s) => s.dialog);
  const close = () => useUi.getState().setDialog(null);
  return (
    <>
      {dialog === 'export' && <ExportDialog onClose={close} />}
      {dialog === 'palette' && <CommandPalette onClose={close} />}
      {dialog === 'shortcuts' && <ShortcutsDialog onClose={close} />}
      {dialog === 'settings' && <ProjectSettingsDialog onClose={close} />}
      <DuplicateDialog />
      <ContextMenuHost />
    </>
  );
}
